"use client";

import { useRouterParams } from "@zapier/shared";
import { Connections } from "./Connections";
import { Apps } from "../apps/Apps";

/**
 * Top-level entry for `/app/assets/connections`. A `?view=apps` query param
 * flips the body from `<Connections />` to `<Apps />` while a unified header
 * (with the View by: Select) reads "Connections" on both views — see APCON-53.
 */
export function ConnectionsRoute() {
  const { view } = useRouterParams();

  if (view === "apps") {
    return <Apps />;
  }
  return <Connections />;
}
